// The figures across the top of the Fee Slips & Invoices page: what is still owing, what is
// waiting to be sorted to a clerk, what has been paid this month, and what is still to be
// recovered from aid. Each is worked out from what the page already has loaded; nothing here
// is fetched or stored.

import { amountOwing, paymentsInPeriod, periodRange, todayIso } from "./paymentReport.js";
import { normalizePaymentStatus } from "./clerkStatements.js";
import { EMAIL_GROUP_NAMES } from "./emailIntake.js";

// Emailed fee slips and invoices the intake could not put under a clerk.
export const TO_SORT_GROUP = EMAIL_GROUP_NAMES.check_type;

const round = (value) => Math.round(value * 100) / 100;

export function feeSlipSummary({ rows = [], payments = [], statusOf = (row) => row.status, recoup = null, now = new Date() } = {}) {
  const unpaid = rows.filter((row) => normalizePaymentStatus(statusOf(row)) !== "paid");
  const toSort = unpaid.filter((row) => row.clerkName === TO_SORT_GROUP);
  const month = periodRange("monthly", todayIso(now));
  const paid = paymentsInPeriod(payments, month);
  return {
    outstanding: { count: unpaid.length, total: round(unpaid.reduce((sum, row) => sum + amountOwing(row, payments), 0)) },
    toSort: { count: toSort.length, total: round(toSort.reduce((sum, row) => sum + amountOwing(row, payments), 0)) },
    paidThisMonth: { count: paid.length, total: round(paid.reduce((sum, payment) => sum + (Number(payment.amount_paid) || 0), 0)), label: month.label },
    toRecover: { count: recoup?.outstandingCount || 0, total: round(recoup?.outstandingTotal || 0) },
  };
}

export const formatAud = (value) => Number(value || 0).toLocaleString("en-AU", { style: "currency", currency: "AUD" });
